import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import API from '@/apiRequest';

export const useUsers = () => {
  const queryClient = useQueryClient();

  const useUsersList = (filters = {}, options = {}) => useQuery({
    queryKey: ['users', filters],
    queryFn: async () => {
      const { data } = await API.get('/users', {
        params: {
          search: filters.text || undefined,
        },
      });
      return data;
    },
    ...options,
  });

  const useUserDetails = (userId, options = {}) => useQuery({
    queryKey: ['users', userId],
    queryFn: async () => {
      const { data } = await API.get(`/users/${userId}`);
      return data;
    },
    enabled: !!userId,
    ...options,
  });

  const useFeaturesList = (options = {}) => useQuery({
    queryKey: ['features'],
    queryFn: async () => {
      const { data } = await API.get('/features');
      return data;
    },
    ...options,
  });

  const useCreateUserMutation = () => useMutation({
    mutationFn: async (userData) => {
      const { data } = await API.post('/users', userData);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
    },
  });

  const useUpdateUserMutation = (userId) => useMutation({
    mutationFn: async (userData) => {
      const { data } = await API.put(`/users/${userId}`, userData);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users', userId] });
      queryClient.invalidateQueries({ queryKey: ['users'] });
    },
  });

  const useDeleteUserMutation = () => useMutation({
    mutationFn: async (userId) => {
      const { data } = await API.delete(`/users/${userId}`);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
    },
  });

  return {
    useUsersList,
    useUserDetails,
    useFeaturesList,
    useCreateUserMutation,
    useUpdateUserMutation,
    useDeleteUserMutation,
  };
};
